// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__34Gly","additionalInfo":"AgreementModal_additionalInfo__1IPHS"};